import "./vendorApLedger.fragment"

import { graphql } from "@/graphql/codegen"

graphql(`
  query GetVendorApLedgerBalance($input: VendorApLedgerGetInput!) {
    vendorApLedger {
      get(input: $input) {
        __typename
        ... on VendorApLedgerGetSuccess {
          vendorApLedger {
            vendorCompanyId
            balance
          }
        }
        ... on VendorApLedgerGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetVendorApLedgerEntries($input: VendorApLedgerListInput!) {
    vendorApLedger {
      list(input: $input) {
        __typename
        ... on VendorApLedgerListSuccess {
          entries {
            ...VendorApLedgerEntryFields
          }
        }
        ... on VendorApLedgerListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
